import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;


@Component({
	selector: 'app-city',
	templateUrl: './city.component.html',
	styleUrls: ['./city.component.css']
})
export class CityComponent implements OnInit {
	cityForm: FormGroup;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	modalTitle: any;
	categoryList: any;
	countryList: any;
	cityList: any
	stateList: any;
	btnTitle: any;
	selectedCityId: any;
	selectedStateId: any
	isCityAvailable: boolean = true;
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	profession: any;
	surveyCategoryList: any;
	category_id: any;
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }




	onChange(category_id) {
		this.cityForm.controls['state_id'].reset();
		var id = category_id.split(': ')
		console.log(id[1]);
		var _id = id[1]
		this.authService.getStateListbyId(_id).subscribe(data => {
			if (data.success) {
				this.stateList = data.state;
			}
		})
	}


	// for update time 
	onChangeEdit(id) {


		// var obj;
		// debugger;;

		//var id = category_id.split(': ')
		//console.log(id[1]);
		//var _id = id[1]
		this.authService.getStateListbyId(id).subscribe(data => {
			if (data.success) {

				this.stateList = data.state;
			}
		})
	}



	ngOnInit() {
		//this.commonService.setTitle();
		$(".navbar-brand").text("City");
		//	$(".navbar-brand").text("category_id");
		this.cityForm = new FormGroup({
			city: new FormControl("", Validators.compose([
				Validators.required,
			])),
			country_id: new FormControl("", Validators.compose([
				Validators.required
			])),

			state_id: new FormControl("", Validators.compose([
				Validators.required
			])),
		});


		// this.professionForm = new FormGroup({
		// 	category_id: new FormControl("", Validators.compose([
		// 		Validators.required,
		// 	])),
		// });

		this.pageNo = 1;
		this.limit = 10;
		//this.getCategoryList(1, this.limit);
		//this.initialiseSurvey();

		//this.getCityList(1, this.limit)  

		this.getCityList(this.pageNo, this.limit, this.searchStr)
		this.getCountryList();
		// // debugger;;
		// this.getStateList();






	}



	//Get City list

	getCityList = function (pageNo, limit, searchStr) {

		this.commonService.process();


		this.authService.getCityList(pageNo, limit, searchStr).subscribe(data => {

			if (data.success) {

				this.cityList = data.city;
				this.isCityAvailable = true;
				console.log(data)
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.isCityAvailable = false;
				this.cityList = [];
				// this.countrycodeList = [];
			}
			this.commonService.hideProcess();
		})
	}




	// Get Country list
	getCountryList = function () {

		//this.commonService.process();
		this.authService.getCountryList().subscribe(data => {
			if (data.success) {

				//this.isCountryAvailable=true;
				// // debugger;;;
				this.countryList = data.country;

				//this.total = data.total;
				// this.setPage(pageNo, true);
				// this.pageNo = pageNo;
			}

			else {
				this.isCountryAvailable = false;
				this.countryList = [];
				// this.countrycodeList = [];
			}

			this.commonService.hideProcess();
			// // debugger;;;
		});


	}









	// Pagination
	setPage(page: number, param) {

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.cityList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getCityList(page, this.limit, this.searchStr);
		}
	}

	// Add State
	addCity = function () {
		// debugger;;

		this.isActivatedAdd = true;
		this.isActivatedEdit = false;
		this.isActivatedDelete = false;
		this.modalTitle = "Add City";
		this.btnTitle = "Save";
		this.selectedStateId = "";
		this.cityForm.reset();


	}

	// Update selected State
	updateSelectedCity = function (city) {
		// debugger;;
		this.isActivatedAdd = false;
		this.isActivatedEdit = true;
		this.isActivatedDelete = false;
		this.modalTitle = "Update City";
		this.btnTitle = "Update";
		this.selectedCityId = city._id;



		this.cityForm.controls['country_id'].setValue(city.country_id._id);
		this.onChangeEdit(city.country_id._id)
		this.cityForm.controls['state_id'].setValue(city.state_id._id);
		this.cityForm.controls['city'].setValue(city.city);
	}

	// Delete Selected state
	deleteSelectedCity = function (city) {
		// debugger;;

		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete City";
		this.btnTitle = "Yes";
		this.selectedCityId = city._id;
		this.city = city;
	}

	// manage new profession
	manageCity = function (cityForm,) {


		if (this.cityForm.valid && this.isActivatedAdd) {
			this.btnTitle = "Saving...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			// debugger;;;
			this.authService.manageCity(cityForm, "add").subscribe(data => {
				if (data.success) {
					// debugger;;
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.getCityList(1, this.limit, this.searchStr);
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.cityForm.valid && this.isActivatedEdit) {
			// debugger;;
			cityForm._id = this.selectedCityId;
			this.btnTitle = "Updating...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			// debugger;;
			this.authService.manageCity(cityForm, "edit", this.selectedCityId).subscribe(data => {
				// debugger;;
				if (data.success) {
					// debugger;;
					this.getCityList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.isActivatedDelete) {
			// debugger;;
			cityForm._id = this.selectedCityId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageCity(cityForm, "delete", this.selectedCityId).subscribe(data => {
				// debugger;;
				if (data.success) {

					this.getCityList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.cityForm);
		}
	}

	// Search city
	searchCity = function () {
		this.searchStr = jQuery("#search").val();
		this.getCityList(1, this.limit, this.searchStr);
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/city/city.component.ts